import { api } from "@/plugins/api";

const state = {
  customers: [],
};

const getters = {
  getAllCustomers: (state) => state.customers,

  getCustomerById: (state) => (id) =>
    state.customers.filter((customer) => customer.id === id),

  getCustomerGroups: (state) => (id) =>
    state.customers
      .find((x) => x.id == id)
      .groups.filter((y) => y.pivot.deleted_at == null),
  getCustomerMeters: (state) => (id) =>
    state.customers
      .find((x) => x.id == id)
      .meters.filter((y) => y.pivot.deleted_at == null),
};

const actions = {
  async fetchAllCustomers({ commit }) {
    try {
      const response = await api.get("/customers");
      const customers = response.data.data;
      commit("setCustomers", customers);
      //return { status: response.status, msg: response.data.message };
      return true;
    } catch (error) {
      //return { status: error.response.status, msg: error.message };
      return false;
    }
  },
  async addCustomer({ commit }, customer) {
    try {
      //console.log("passed data", customer);
      const response = await api.post("/customers", customer);
      //console.log("response", response);
      commit("addCustomer", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async addCustomerWithMeter({ commit }, formData) {
    try {
      const customerFormData = {
        name: formData.name,
        phone: formData.phone,
        address: formData.address,
        balance: formData.balance,
      };
      const meterFormData = {
        code: formData.meter_code,
        name: formData.meter_name,
        status: formData.meter_status,
        parent_id: formData.meter_parent_id,
        isFinal: 1,
      };
      const response1 = await api.post("/customers", customerFormData);
      const response2 = await api.post("/meters", meterFormData);
      const customer_id = response1.data.data.id;
      const meter_id = response2.data.data.id;

      const response3 = await api.post(`/customers/${customer_id}/meters/add`, {
        meter_id: meter_id,
        added_at: new Date().toISOString().substring(0, 10),
        initial_reading: formData.initial_reading,
      });
      console.log("response1", response1.data.data);
      console.log("customer_id", customer_id);
      commit("addCustomer", response1.data.data);
      commit("addCustomerMeter", {
        meter: response3.data.data,
        cid: customer_id,
      });

      return true;
    } catch (error) {
      return false;
    }
  },
  async updateCustomer({ commit }, customer) {
    try {
      const id = customer.id;
      //console.log("passed data", customer);
      customer._method = "put";
      const response = await api.post(`/customers/${id}`, customer);
      console.log("updated", response.data);
      commit("updateCustomer", response.data.data);
      return true;
    } catch (error) {
      //console.log("error", error.message);
      return false;
    }
  },
  async deleteCustomer({ commit }, id) {
    try {
      //const response = await api.delete(`/customers/${id}`);
      const response = await api.delete(`/customers/${id}`);
      console.log("response", response);
      if (response) {
        commit("removeCustomer", id);
      }
      //return response.data.message;
      return true;
    } catch (error) {
      //console.log("response", error);
      //return error.message;
      return false;
    }
  },
  async addToGroup({ commit }, data) {
    try {
      const response = await api.post(
        `/customers/${data.customer_id}/groups/add`,
        {
          group_id: data.group_id,
          added_at: new Date().toISOString().substring(0, 10),
        }
      );
      commit("addCustomerToGroup", {
        group: response.data.data,
        cid: data.customer_id,
      });
      return true;
    } catch (error) {
      return false;
    }
  },
  async removeFromGroup({ commit }, data) {
    try {
      const response = await api.post(
        `/customers/${data.customer_id}/groups/remove`,
        {
          group_id: data.group_id,
          deleted_at: new Date().toISOString().substring(0, 10),
        }
      );
      console.log("re move", response.data.data);
      commit("remCustFromGroup", {
        group: response.data.data,
        cid: data.customer_id,
      });
      console.log("re movedddddd", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async addMeterToCustomer({ commit }, data) {
    try {
      const response = await api.post(
        `/customers/${data.customer_id}/meters/add`,
        {
          meter_id: data.meter_id,
          added_at: new Date().toISOString().substring(0, 10),
          initial_reading: data.initial_reading,
        }
      );
      commit("addCustomerMeter", {
        meter: response.data.data,
        cid: data.customer_id,
      });
      return true;
    } catch (error) {
      return false;
    }
  },
  async removeMeterFromCustomer({ commit }, data) {
    try {
      const response = await api.post(
        `/customers/${data.customer_id}/meters/remove`,
        {
          meter_id: data.meter_id,
          deleted_at: new Date().toISOString().substring(0, 10),
        }
      );
      commit("remCustomerMeter", {
        meter: response.data.data,
        cid: data.customer_id,
      });
      return true;
    } catch (error) {
      return false;
    }
  },
  async updateMeterOfCustomer({ commit }, data) {
    try {
      const response = await api.post(
        `/customers/${data.customer_id}/meters/update`,
        {
          meter_id: data.meter_id,
          initial_reading: data.initial_reading,
        }
      );
      commit("updateCustomerMeter", {
        meter: response.data.data,
        cid: data.customer_id,
      });
      return true;
    } catch (error) {
      return false;
    }
  },
};

const mutations = {
  addCustomerToGroup(state, data) {
    let index = state.customers.findIndex((x) => x.id == data.cid);
    try {
      state.customers[index].groups.push(data.group);
    } catch (e) {
      console.log(e.message);
    }
  },
  remCustFromGroup(state, data) {
    let index = state.customers.findIndex((x) => x.id == data.cid);
    try {
      state.customers[index].groups = state.customers[index].groups.filter(
        (x) => x.id != data.group.id
      );
    } catch (e) {
      console.log(e.message);
    }
  },
  addCustomerMeter(state, data) {
    console.log("data", data);
    let index = state.customers.findIndex((x) => x.id == data.cid);
    console.log("index", index);
    try {
      console.log("state", state.customers);
      console.log("state", state.customers[index]);
      if (state.customers[index].meters == undefined) {
        state.customers[index].meters = [];
      }
      state.customers[index].meters.push(data.meter);
    } catch (e) {
      console.log("error", e.message);
    }
  },
  remCustomerMeter(state, data) {
    let index = state.customers.findIndex((x) => x.id == data.cid);
    try {
      state.customers[index].meters = state.customers[index].meters.filter(
        (x) => x.id != data.meter.id
      );
    } catch (e) {
      console.log(e.message);
    }
  },
  updateCustomerMeter(state, data) {
    let index = state.customers.findIndex((x) => x.id == data.cid);
    let mindex = state.customers[index].meters.findIndex(
      (x) => x.id == data.meter.id
    );
    try {
      state.customers[index].meters[mindex].initial_reading =
        data.meter.pivot.initial_reading;
    } catch (e) {
      console.log(e.message);
    }
  },
  setCustomers(state, customers) {
    state.customers = customers;
    //console.log("mu", state.customers);
  },
  addCustomer(state, customer) {
    //console.log("uses is:", customer);
    //state.customers.unshift(customer);
    state.customers.push(customer);
    //console.log("uses updated:", state.customers);
  },
  removeCustomer(state, id) {
    const index = state.customers.findIndex((customer) => customer.id == id);
    if (index !== -1) {
      state.customers.splice(index, 1);
    }
  },
  updateCustomer(state, customer) {
    const id = customer.id;
    const index = state.customers.findIndex((customer) => customer.id == id);
    if (index !== -1) {
      state.customers[index] = customer;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
